/**
 * Home Stats ASK — compteur animé au scroll
 * - IntersectionObserver pour déclencher quand visible
 * - Support entier (1 234), décimal (4,7), brut (sans anim)
 * - Format français pour les milliers
 */
(function () {
  'use strict';
  if (window.__askStatsReady) return;
  window.__askStatsReady = true;

  function formatNumber(n, format) {
    if (format === 'decimal') {
      return n.toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    }
    return Math.round(n).toLocaleString('fr-FR');
  }

  const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animateCounter(el) {
    const item = el.closest('[data-stat]');
    if (!item || item.__animated) return;
    item.__animated = true;
    const target = parseFloat(item.getAttribute('data-target')) || 0;
    const format = item.getAttribute('data-format') || 'int';

    if (format === 'raw' || prefersReducedMotion || target === 0) {
      el.textContent = format === 'raw' ? (item.getAttribute('data-target') || '0') : formatNumber(target, format);
      return;
    }

    // Reset au demarrage de l'animation (le HTML contient deja la valeur cible en fallback)
    el.textContent = formatNumber(0, format);

    const duration = 1600;
    const start = performance.now();
    function tick(now) {
      const elapsed = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - elapsed, 4);
      el.textContent = formatNumber(target * eased, format);
      if (elapsed < 1) requestAnimationFrame(tick);
      else el.textContent = formatNumber(target, format);
    }
    requestAnimationFrame(tick);
  }

  function setupSection(section) {
    const items = section.querySelectorAll('[data-stat]');
    if (!items.length) return;

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const item = entry.target;
          item.classList.add('is-visible');
          const counter = item.querySelector('[data-counter]');
          if (counter) animateCounter(counter);
          obs.unobserve(item);
        }
      });
    }, { threshold: 0.4, rootMargin: '0px 0px -50px 0px' });

    items.forEach((it) => obs.observe(it));
  }

  function init() {
    document.querySelectorAll('[data-stats]').forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
